import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/layouts/DashboardLayout";

const Documents = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Documents - Numberz Insight</title>
        <meta name="description" content="Access and manage your important documents and files." />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-semibold mb-6">Documents</h1>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
          <p className="text-gray-600 dark:text-gray-300">Document management features coming soon.</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Documents;